import React from "react";
import { motion } from "framer-motion";
import { assetUrl } from "@/contexts/SessionContext";

/** OK FBI official luxury golden emblem */
export function OkFbiEmblem({ size = 96, className = "" }) {
  return (
    <div className={`inline-flex flex-col items-center select-none ${className}`} data-testid="okfbi-emblem">
      <img
        src={assetUrl("/generated_images/okfbi-emblem-4k-transparent.png")}
        alt="OK FBI"
        style={{
          width: size,
          height: "auto",
          maxWidth: "100%",
          filter: "drop-shadow(0 8px 24px rgba(0,0,0,0.75)) drop-shadow(0 2px 6px rgba(197,160,89,0.18))",
          background: "transparent",
        }}
        className="object-contain"
        draggable={false}
        onError={(e) => {
          if (!e.target.dataset.triedFallback) {
            e.target.dataset.triedFallback = "1";
            e.target.src = "/generated_images/okfbi-emblem-4k-transparent.png";
          }
        }}
      />
    </div>
  );
}

/** Paper clip SVG (metallic) */
export function PaperClip({ className = "" }) {
  return (
    <svg className={className} viewBox="0 0 40 60" width="30" height="45">
      <defs>
        <linearGradient id="clipMetal" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#DDDDE0" />
          <stop offset="50%" stopColor="#8A8A90" />
          <stop offset="100%" stopColor="#4A4A50" />
        </linearGradient>
      </defs>
      <path d="M8 5 Q8 2 12 2 L28 2 Q32 2 32 8 L32 45 Q32 55 22 55 Q12 55 12 45 L12 15 Q12 10 16 10 L26 10 Q28 10 28 14 L28 40" 
        stroke="url(#clipMetal)" strokeWidth="3" fill="none" strokeLinecap="round" />
    </svg>
  );
}

/** Confidential stamp */
export function ConfidentialStamp({ text = "سري للغاية", className = "" }) {
  return (
    <div className={`inline-block ${className}`} style={{ transform: "rotate(-8deg)" }}>
      <div className="border-[3px] border-red-800 text-red-800 font-bold px-3 py-1 text-xs tracking-widest opacity-70" style={{ letterSpacing: "0.3em", fontFamily: "Cairo, serif" }}>
        {text}
      </div>
    </div>
  );
}

/** Animated fade-slide wrapper */
export const Fade = ({ children, delay = 0 }) => (
  <motion.div initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay }}>
    {children}
  </motion.div>
);
